// ./src/config/crewCapabilities.ts
//
// Crew capability strings — a FE MIRROR of the API's boundary/crewAccess.ts
// CREW_CAPABILITY. The BE is the authoritative gate; the FE uses these only to
// hide/show nav + controls the caller can't use. Keep in sync with the API.
export const CREW_CAPABILITY = {
  EVENT_VIEW: "event.view",
  EVENT_OPERATE: "event.operate",
  EVENT_SETTINGS: "event.settings",
  EVENT_DELETE: "event.delete",
  GUESTS_VIEW: "guests.view",
  GUESTS_RSVP: "guests.rsvp",
  GUESTS_EDIT: "guests.edit",
  CHECKIN: "checkin",
  BUDGET_VIEW: "budget.view",
  BUDGET_EDIT: "budget.edit",
  SIGNUPS_MANAGE: "signups.manage",
  COMMENTS_POST: "comments.post",
  COMMENTS_MODERATE: "comments.moderate",
  MESSAGING_SEND: "messaging.send",
  WEBSITE_EDIT: "website.edit",
  CREW_MANAGE: "crew.manage",
  TICKETS_MANAGE: "tickets.manage",
  /** Redeem a voucher at a stall — the voucher redeemer's only capability (staff reach it through `checkin`). */
  VOUCHERS_REDEEM: "vouchers.redeem",
  /** #68 — lost & found: log, receive, match, hand back, dispose (host, co-host, organizer, staff). */
  LOSTFOUND_MANAGE: "lostfound.manage",
} as const;

export type CrewCapability = (typeof CREW_CAPABILITY)[keyof typeof CREW_CAPABILITY];

/** Human labels for crew roles (guest_role values that count as crew). */
export const CREW_ROLE_LABELS: Record<string, string> = {
  co_host: "Co-host",
  organizer: "Organizer",
  staff: "Staff",
  volunteer: "Volunteer",
  vendor: "Vendor",
  speaker: "Speaker",
  performer: "Performer",
  other: "Crew",
  voucher_redeemer: "Voucher redeemer",
};

/** The capabilities that may redeem a voucher at a stall (mirrors the API's VOUCHER_REDEEM_CAPABILITIES). */
export const VOUCHER_REDEEM_CAPABILITIES: string[] = [CREW_CAPABILITY.TICKETS_MANAGE, CREW_CAPABILITY.CHECKIN, CREW_CAPABILITY.VOUCHERS_REDEEM];

export const crewRoleLabel = (role: string | null | undefined): string =>
  (role && CREW_ROLE_LABELS[role]) || "Crew";
